/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import BankDetails from "./BankDetails.container";

export default BankDetails;
